import { AddActionIcon, FileTreeContextMenu } from '@common';
import { Menu } from '@mantine/core';

type AddTreeItemMenuPropsType = {
  onAddFolder: () => void;
  onAddFile: () => void;
};

export const AddTreeItemMenu: React.FC<AddTreeItemMenuPropsType> = ({
  onAddFolder,
  onAddFile,
}) => {
  return (
    <Menu>
      <Menu.Target>
        <AddActionIcon />
      </Menu.Target>
      <Menu.Dropdown>
        <FileTreeContextMenu.CreateSubfolder onClick={onAddFolder} />
        <FileTreeContextMenu.UploadFile onClick={onAddFile} />
      </Menu.Dropdown>
    </Menu>
  );
};
